/**
 * AccentMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Bottom green-tinted gradient mask.
 */
const AccentMask = styled.div`
  background: linear-gradient(171deg, rgba(0, 0, 0, 0) 73.18%, #50e3c2 100.44%);
  bottom: 0;
  height: ${490 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 2;
`;

export default withOpacity(AccentMask);
